import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { CLINIC } from "../../data/content";

export default function MobileBottomBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const waHref = `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(
    "Hello Physio Hyve, I'd like to enquire about physiotherapy."
  )}`;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[100] px-3 pb-3">
      <div className="bg-white/95 backdrop-blur-xl border border-black/5 rounded-2xl shadow-[0_-8px_30px_rgba(0,0,0,0.08)] grid grid-cols-3 overflow-hidden">
        <a href={`tel:${CLINIC.phoneRaw}`} data-testid="mbar-call" className="flex flex-col items-center gap-1 py-3 text-brand-olive">
          <Phone size={18}/><span className="text-[11px] font-medium">Call</span>
        </a>
        <a href={waHref} data-testid="mbar-whatsapp" target="_blank" rel="noreferrer" className="flex flex-col items-center gap-1 py-3 border-x border-black/5 text-brand-terracotta">
          <MessageCircle size={18}/><span className="text-[11px] font-medium">WhatsApp</span>
        </a>
        <Link to="/book" data-testid="mbar-book" className="flex flex-col items-center gap-1 py-3 text-brand-olive">
          <CalendarCheck size={18}/><span className="text-[11px] font-medium">Book</span>
        </Link>
      </div>
    </div>
  );
}
